import { IParamGetNewsCrawler, IParamUpdateNewsCrawler } from "@interfaces/iparam-news-crawler"

const baseUrl: string = process.env.REACT_APP_API_URL || ''
class NewsCrawler {
  private uri: string

  constructor(uri: string) {
    this.uri = uri
  }

  public read = (params: IParamGetNewsCrawler) => ({
    baseUrl,
    method: 'get',
    params,
    uri: this.uri,
  })

  public update = (params: IParamUpdateNewsCrawler) => ({
    baseUrl,
    method: 'post',
    params,
    uri: this.uri,
  })

  public readOne = (id: any) => ({
    baseUrl,
    method: 'get',
    uri: `${this.uri}/${id}`,
  })

  public readNewsMedia = () => ({
    baseUrl,
    method: 'get',
    uri: `${this.uri}/news-media`
  })

  public manualFetch = () => ({
    baseUrl,
    method: 'post',
    uri: `${this.uri}/crawl-all`
  })
}

export default new NewsCrawler('/othermedia/v1')


// WEBPACK FOOTER //
// ./src/libraries/api/news-crawler.tsx